import { createUseStyles } from "react-jss";
//import { apaTheme } from "../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      width: "100%",
      boxSizing: "border-box",
    },
    inputWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      alignItems: "flex-start",
      height: "66px",
      padding: "12px 16px",
      width: '100% !important'
    },
    labelWrapper: {
      display: "flex",
      flexDirection: "row",
      gap: "3px",
    },
    labelRequired: {
      color: "#6B6B6C",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "18px",
    },
    label: {
      color: "#6B6B6C",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "18px",
    },
    icon: {
      lineHeight: "7px",
    },
  })();
};
